export * from './authId';
export * from './constant';
export * from './diff';
export * from './domain';
export * from './env';
export * from './envConfig';
export * from './global';
export * from './sms';
export * from './tool';
import { BRAND_NAME } from './constant';
import { brand } from './env';

export const getBrand = (): string => brand;
export const setBrand = (brand: string): void => localStorage.setItem(BRAND_NAME, brand);
export const removeBrand = (): void => localStorage.removeItem(BRAND_NAME);
